export type Assistant = {
    id: string,
    created_by: string,
    user_display_name: string,
    created_at: string,
    assistant: string,
    type: string,
    title: string,
    system_prompt_message: string,
    files: File[];
    examples: string[],
    attachments: string[],
    contact: Record<string, any>;
    userIds: string[],
    groups: string[],
    adminIds: string[],
    adminGroups: string[],
    fileManagerIds: string[],
    fileManagerGroups: string[],
    name: string,
    available: boolean
}

export type Message = {
    role: string;
    content: string;
};

export type MessageContext = {
    metadata?: Record<string, any>;
    followup_questions?: string[] | null;
    assistant_id?: string;
    assistant_prompt_message?: string;
    stopped?: boolean;
    aborted_before_first_token?: boolean;
};

export type Choice = {
    index: number;
    message: Message;
    context: MessageContext;
    session_state: any;
    message_id: string | null;
    feedback?: string | null;
};

export type ChatResponse = {
    choices: Choice[];
};

export type ChatResponseOrError = {
    choices?: Choice[];
    error?: string;
};

export type ChatRequest = {
    assistant: string;
    messages: Message[];
    context: MessageContext;
    stream?: boolean;
    session_state: any;
};

export type ChatMessage = {
    id: string | null;
    message: Message;
    context: MessageContext;
    date: string;
    feedback?: string;
};

export type Conversation = {
    id: string;
    assistant: string;
    assistant_id: string;
    title: string;
    messages: ChatMessage[];
    date: string;
    pinned?: boolean;
};

export type HistoryRequest = {
    conversation_id?: string;
    assistant: string;
    assistant_id: string;
    messages: Message[];
    context: MessageContext;
    user_context?: MessageContext;
};

export enum CosmosDBStatus {
    NotConfigured = "CosmosDB is not configured",
    NotWorking = "CosmosDB is not working",
    Working = "CosmosDB is configured and working"
}

export type CosmosDBHealth = {
    cosmosDB: boolean;
    status: string;
};

export enum ChatHistoryLoadingState {
    Loading = "loading",
    Success = "success",
    Fail = "fail",
    NotStarted = "notStarted"
}

export enum AssistantsLoadingState {
    Loading = "loading",
    Success = "success",
    Fail = "fail",
    NotStarted = "notStarted"
}

export type FeedbackRequest = {
    message_id: string;
    feedback: string | null;
};

export type ErrorResponse = {
    error: string;
};

export type SendEmailRequest = {
    subject: string;
    question: string;
    messages: ChatMessage[];
    recipient: string;
    assistant_name: string;
};

export interface ApiResponse<T> {
    ok: boolean;
    status: number;
    data?: T;
}

export interface FileUploadError {
    filename: string;
    error: string;
}

export interface FileUploadResponse {
    uploaded_files: string[];
    errors?: FileUploadError[];
}

export type ImageInput = {
    name: string;
    dataUrl: string;
    mimeType: string;
    size: number;
};

export type AuthClaims = {
    oid: string;
    groups: string[];
}
export interface AzureGroup {
    id: string
    displayName: string
    mail?: string
    objectType: "group"
}
export interface User {
    id: string
    displayName: string
    mail: string
    objectType: "user"
}

export type SearchEntity = User | AzureGroup

export type DeleteConversationResponse = {
    deleted_conversation_id: string
    deleted_chat_ids: string[]
}

export type UpdateTitleResponse = {
    conversation_id: string;
    title: string;
}

